import { useDispatch, useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { useGetLoggedInMutation } from '../../services/keycloak';
import LoginForm from './components/LoginForm';
import styles from './index.module.scss';
import type { RootState } from '../../services/reduxStore';
import { setCredentials } from '../../services/reduxStore/auth';

const { loginPage } = styles;

// eslint-disable-next-line no-underscore-dangle
const offlineModeEnabled = (window as any)._env_.REACT_APP_OFFLINE_MODE === 'true';

function Login() {
  const dispatch = useDispatch();
  const [login, { isLoading, isSuccess, data }] = useGetLoggedInMutation();
  const isLoggedIn = useSelector(({ auth } : RootState) => auth.isLoggedIn);

  if (isSuccess) {
    if (data) {
      dispatch(setCredentials(data));
    }
    return <Navigate to="/app/map" />;
  }

  return (isLoggedIn || offlineModeEnabled) ? <Navigate to="/app/map" /> : (
    <div className={loginPage}>
      <div>
        <img src={process.env.PUBLIC_URL.concat('/dtn-logo.webp')} alt="DTN logo" />
        <LoginForm
          loading={isLoading}
          onSubmit={({ password, username }) => {
            login({ password, username });
          }}
        />
      </div>
    </div>
  );
}

export default Login;
